<template>
  <d-form @submit.prevent="save">
    <d-form-row class="form-group">
      <d-col cols="12">
        <label>Palavra:</label>
          <autocomplete
            ref="search"
            placeholder="Escreva a palavra"
            :items="words"
            item-show="word"
            :on-input="onInputWord"
            :on-blur="setWord"
            :state="hasErrorFiled('word')"
          ></autocomplete>
          <d-form-invalid-feedback>Este campo é obrigatório</d-form-invalid-feedback>
      </d-col>
      <d-col cols="12" class="mt-3 d-flex justify-content-end">
        <button type="submit" class="btn btn-primary">Salvar</button>
      </d-col>
    </d-form-row>
  </d-form>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import mixin from '_common/mixins/ValidateForm';
import formatErrors from '_common/mixins/FormatErrors';
import Autocomplete from '_shared/Autocomplete.vue';
import Events from '_utils/events';
import WordService from '_services/rest/modules/word';
import {
  MODEL,
  _LOAD_MODEL_,
} from './WordModel';

export default {
  name: 'word-form',
  mixins: [mixin, formatErrors],
  components: {
    Autocomplete,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      words: [],
      errors: {
        word: { required: false },
      },
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    onInputWord(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getWords(name);
      }, 500);
    },
    getWords(params) {
      WordService.getWords({ search: params })
        .then(response => {
          this.words = response.list;
        });
    },
    setWord(word) {
      this.model.word = word;
    },
    save() {
      if (!this.model.word) {
        this.setWord(this.$refs.search.$refs.input.value);
      }
      if (this.checkForm()) {
        WordService.save(this.model)
          .then(() => {
            this.activeAlert({ message: 'Palavra salva com successo!', theme: 'success' });
            this.model = cloneDeep(MODEL);
            this.submitted = false;
            this.$refs.search.$refs.input.value = null;
            this.$refs.search.$refs.input.focus();
          })
          .catch(error => {
            const errors = this.formatErrors(error.data);
            this.activeAlert({ message: errors, theme: 'danger' });
          });
      }
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, model => {
      this.model = model;
    });
  },
};
</script>

<style lang="scss" scoped>
</style>
